import * as React from 'react';

import './UserAvatar.scss';
import { addModifiers } from '../../shared/helpers';

interface UserAvatarProps {
  image?: string;
  initials: string;
  size?: 's' | 'm' | 'l';
}

export function UserAvatar({ image, initials, size = 's' }: UserAvatarProps) {
  const containerClassModifiers = [];
  const style: { backgroundColor: undefined | string } = {
    backgroundColor: undefined,
  };
  const modifier = getModifier(size);
  if (modifier) {
    containerClassModifiers.push(modifier);
  }

  if (!image) {
    containerClassModifiers.push('default');
    style.backgroundColor = getColor(initials);
  }

  return (
    <div className={addModifiers('user-avatar', containerClassModifiers)} style={style}>
      {image && <img className={addModifiers('user-avatar__image', modifier ? [modifier] : [])} src={image}></img>}
    </div>
  );
}

function getModifier(size: string) {
  if (size === 'l') {
    return 'large';
  }
  if (size === 'm') {
    return 'medium';
  }
}

const colors = [
  '#2e7271',
  '#ba3066',
  '#397724',
  '#974397',
  '#616d20',
  '#5f5bb0',
  '#895f24',
  '#506690',
  '#ae442e',
  '#3b724c',
  '#92515f',
  '#6f643c',
];

//seeded random number generator
//https://gist.github.com/tommyettinger/46a874533244883189143505d203312c
//https://stackoverflow.com/a/47593316
function mulberry32(a: number) {
  let t = (a += 0x6d2b79f5);
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

function getColor(initials: string) {
  return colors[Math.floor(mulberry32(initials.charCodeAt(0) + 100 * initials.charCodeAt(1)) * colors.length)];
}
